import React, { useState, useEffect } from "react";
import StaticPageHeaders from "../../Components/StaticPageHeaders";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import Swal from "sweetalert2";
import { Calendar } from "primereact/calendar";
import "./style.css"; // Keeping for colors and fonts

const BirthdayPartiesRegistration = () => {
  const [formData, setFormData] = useState({
    parentName: "",
    phoneNumber: "",
    email: "",
    childName: "",
    childDob: null,
    partyDate: null,
    startTime: "", // Will hold "HH:MM AM/PM"
    startTimeHH: "12",
    startTimeMM: "00",
    startTimeAmpm: "PM",

    numberOfPlayers: "20",
    gymSpace: "3 Hours - $450", // 450, 600, 750
    equipmentRental: "Yes",

    // Pizza
    pizzaOption: "Yes", // Mandatory $7 per player
    // Cake
    customCake: "No", // "If yes, add $3 per player." or "No"
    cakeOption: "",

    // Adults
    numberOfAdults: "20",
    adultFoodOption: "No", // "Yes...", "Yes...", "No"
    // Hidden Vendor Fee handled by logic

    // Adult Menus
    adultFoodList1: "",
    adultFoodList2: "",
    adultFoodList3: "",

    // Add-ons (Checkboxes)
    goodieBags: false,
    tShirts: false,
    jerseys: false,
    pinata: false,
    rubberBasketballs: false,

    notes: "",
  });

  const [totalPrice, setTotalPrice] = useState(0);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "phoneNumber") {
      // Allow only numbers and limit to 10 digits
      const re = /^[0-9\b]+$/;
      if (value === "" || (re.test(value) && value.length <= 10)) {
        setFormData((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const handleTimeChange = (field, value) => {
    setFormData((prev) => {
      const newData = { ...prev, [field]: value };
      // Update combined startTime
      newData.startTime = `${newData.startTimeHH}:${newData.startTimeMM} ${newData.startTimeAmpm}`;
      return newData;
    });
  };

  const handleDateChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    calculateTotal();
    // Update combined start time string whenever components change
    setFormData((prev) => ({
      ...prev,
      startTime: `${prev.startTimeHH}:${prev.startTimeMM} ${prev.startTimeAmpm}`,
    }));
  }, [
    formData.numberOfPlayers,
    formData.gymSpace,
    formData.equipmentRental,
    formData.pizzaOption,
    formData.customCake,
    formData.numberOfAdults,
    formData.adultFoodOption,
    formData.goodieBags,
    formData.tShirts,
    formData.jerseys,
    formData.pinata,
    formData.rubberBasketballs,
    formData.startTimeHH,
    formData.startTimeMM,
    formData.startTimeAmpm,
  ]);

  const getSpecialistPackage = (numPlayers) => {
    const count = parseInt(numPlayers) || 0;
    if (count > 30) return { count: 4, price: 600 };
    if (count > 20) return { count: 3, price: 450 };
    return { count: 2, price: 300 };
  };

  const calculateTotal = () => {
    let total = 0;
    const players = parseInt(formData.numberOfPlayers) || 0;
    const adults = parseInt(formData.numberOfAdults) || 0;

    // Gym Space
    if (formData.gymSpace === "3 Hours - $450") total += 450;
    else if (formData.gymSpace === "4 Hours - $600") total += 600;
    else if (formData.gymSpace === "5 Hours - $750") total += 750;

    // Equipment Rental ($75)
    if (formData.equipmentRental === "Yes") total += 75;

    // Specialists Cost (Dynamic)
    const { price } = getSpecialistPackage(players);
    total += price;

    // Pizza & Soda ($7 per player) - Mandatory
    total += players * 7;

    // Cake (If Yes, add $3 per player)
    // The value matches the label now
    if (formData.customCake === "If yes, add $3 per player.") {
      total += players * 3;
    }

    // Adults Food
    if (
      formData.adultFoodOption ===
      "Yes, I would like to utilize the options available from Shootin’ School. (add $18 per number of Adults selected)"
    ) {
      total += adults * 18;
    } else if (
      formData.adultFoodOption ===
      "Yes, however, we will bring our own food (add $150 outside food vendor))"
    ) {
      total += 150; // Outside Vendor Fee
    }

    // Add-ons
    // "each" implies per player for these items
    if (formData.goodieBags) total += players * 10;
    if (formData.tShirts) total += players * 12;
    if (formData.jerseys) total += players * 25;
    if (formData.pinata) total += 100; // Flat fee
    if (formData.rubberBasketballs) total += players * 15;

    setTotalPrice(total);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    // 1. Phone Number Validation
    if (formData.phoneNumber.length !== 10) {
      Swal.fire({
        icon: "error",
        title: "Invalid Phone Number",
        text: "Please enter a valid 10-digit phone number.",
        confirmButtonColor: "#f7931a",
      });
      return;
    }

    // 2. Email Validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      Swal.fire({
        icon: "error",
        title: "Invalid Email",
        text: "Please enter a valid email address.",
        confirmButtonColor: "#f7931a",
      });
      return;
    }

    // 3. Date Validation
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (formData.childDob && new Date(formData.childDob) > today) {
      Swal.fire({
        icon: "error",
        title: "Invalid Date of Birth",
        text: "Date of Birth cannot be in the future.",
        confirmButtonColor: "#f7931a",
      });
      return;
    }

    if (formData.partyDate && new Date(formData.partyDate) < today) {
      Swal.fire({
        icon: "error",
        title: "Invalid Party Date",
        text: "Party Date cannot be in the past.",
        confirmButtonColor: "#f7931a",
      });
      return;
    }

    if (
      formData.adultFoodOption ===
      "Yes, I would like to utilize the options available from Shootin’ School. (add $18 per number of Adults selected)"
    ) {
      if (
        !formData.adultFoodList1 ||
        !formData.adultFoodList2 ||
        !formData.adultFoodList3
      ) {
        Swal.fire({
          icon: "error",
          title: "Missing Information",
          text: "Please select one item from each Adult Menu list.",
          confirmButtonColor: "#f7931a",
        });
        return;
      }
    }

    if (
      formData.customCake === "If yes, add $3 per player." &&
      !formData.cakeOption
    ) {
      Swal.fire({
        icon: "error",
        title: "Missing Information",
        text: "Please select a Cake Type.",
        confirmButtonColor: "#f7931a",
      });
      return;
    }

    // Helper to format date as YYYY-MM-DD
    const formatDate = (date) => {
      if (!date) return "";
      const d = new Date(date);
      let month = "" + (d.getMonth() + 1);
      let day = "" + d.getDate();
      const year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    };

    // Construct Party Favors Array
    let favors = [];
    if (formData.goodieBags) {
      favors.push(
        "Shootin’ School Goodie Bag Favor - Custom Shootin’ School Water bottle with assorted candies wrapped in cellophane packaging - $10 each",
      );
    }
    if (formData.tShirts) {
      favors.push("Shootin’ School T-Shirts ($12 each)");
    }
    if (formData.jerseys) {
      favors.push("Official Shootin’ School Mesh Practice Jersey ($25 each)");
    }
    if (formData.pinata) {
      favors.push("Basketball Pinata ($100)");
    }
    if (formData.rubberBasketballs) {
      favors.push("Shootin’ School Rubber Basketballs ($15 each)");
    }

    // Prepare Payload
    const payload = {
      parent_name: formData.parentName,
      parent_phone: formData.phoneNumber,
      parent_email: formData.email,
      child_name: formData.childName,
      child_dob: formatDate(formData.childDob),
      party_date: formatDate(formData.partyDate),
      start_time: formData.startTime,
      player_count: String(formData.numberOfPlayers),

      gym_package: formData.gymSpace,
      equipment_rental: formData.equipmentRental,
      specialists_package: (() => {
        const { count, price } = getSpecialistPackage(formData.numberOfPlayers);
        return `${count} Specialists - $${price}`;
      })(),

      pizza_package: "$7 Per Player",

      custom_cake: formData.customCake,
      cake_option:
        formData.customCake === "If yes, add $3 per player."
          ? formData.cakeOption
          : "-",

      adult_count: String(formData.numberOfAdults),
      adult_food_option: formData.adultFoodOption,

      menu_list_1:
        formData.adultFoodOption ===
        "Yes, I would like to utilize the options available from Shootin’ School. (add $18 per number of Adults selected)"
          ? formData.adultFoodList1
          : "-",
      menu_list_2:
        formData.adultFoodOption ===
        "Yes, I would like to utilize the options available from Shootin’ School. (add $18 per number of Adults selected)"
          ? formData.adultFoodList2
          : "-",
      menu_list_3:
        formData.adultFoodOption ===
        "Yes, I would like to utilize the options available from Shootin’ School. (add $18 per number of Adults selected)"
          ? formData.adultFoodList3
          : "-",

      party_favors: favors.length > 0 ? favors : "-",

      total_price: totalPrice,

      notes: formData.notes || "-",
    };

    // Show Loading
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your registration.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await fetch(
        "https://services.leadconnectorhq.com/hooks/CL8kBGrERKWFyIMGQBcF/webhook-trigger/96ab0772-cf86-44b3-bcf8-cf289513bddc",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Registration Submitted!",
          text: "We have received your party registration details.",
          confirmButtonColor: "#f7931a",
        });
        // Optional: Reset form here if needed
        // setFormData(initialState);
      } else {
        throw new Error("Server responded with an error");
      }
    } catch (error) {
      console.error("Submission Error:", error);
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: "There was an issue submitting your registration. Please try again.",
        confirmButtonColor: "#f7931a",
      });
    }
  };

  return (
    <div className="birthday-registration-page">
      <StaticPageHeaders title="Birthday Parties Registration Form" />

      {/* Forced full width container */}
      <div style={{ "--br-value": 1.28 }} className="bg-custom brightness">
        <Container
          fluid
          className="py-5"
          style={{
            width: "95%",
            maxWidth: "none",
            margin: "0 auto",
            filter: "brightness(0.76)",
          }}
        >
          <Card
            className="shadow-lg border-0"
            style={{ borderRadius: "12px", borderTop: "5px solid #f7931a" }}
          >
            <Card.Body className="p-4 p-md-5">
              <Form onSubmit={handleSubmit}>
                {/* 1. Personal & Event Information */}
                <h5
                  className="mb-4"
                  style={{ color: "#f7931a", fontWeight: "bold" }}
                >
                  Personal & Event Information
                </h5>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Name (Parent){" "}
                    <span
                      className="text-danger"
                      style={{ fontSize: "0.9rem", fontWeight: "normal" }}
                    >
                      <span style={{ fontSize: "0.7rem", fontStyle: "italic" }}>
                        (Required)
                      </span>
                    </span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="parentName"
                    placeholder="Full Name"
                    value={formData.parentName}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold">
                        Phone Number{" "}
                        <span
                          className="text-danger"
                          style={{ fontSize: "0.9rem", fontWeight: "normal" }}
                        >
                          <span
                            style={{ fontSize: "0.7rem", fontStyle: "italic" }}
                          >
                            (Required)
                          </span>
                        </span>
                      </Form.Label>
                      <Form.Control
                        type="tel"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleInputChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold">
                        Email Address{" "}
                        <span
                          className="text-danger"
                          style={{ fontSize: "0.9rem", fontWeight: "normal" }}
                        >
                          <span
                            style={{ fontSize: "0.7rem", fontStyle: "italic" }}
                          >
                            (Required)
                          </span>
                        </span>
                      </Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold">
                        Birthday Boy/Girl Name{" "}
                        <span
                          className="text-danger"
                          style={{ fontSize: "0.9rem", fontWeight: "normal" }}
                        >
                          <span
                            style={{ fontSize: "0.7rem", fontStyle: "italic" }}
                          >
                            (Required)
                          </span>
                        </span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="childName"
                        placeholder="Full Name"
                        value={formData.childName}
                        onChange={handleInputChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold">
                        Date of Birth (Of Birthday Boy/Girl){" "}
                        <span
                          className="text-danger"
                          style={{ fontSize: "0.9rem", fontWeight: "normal" }}
                        >
                          <span
                            style={{ fontSize: "0.7rem", fontStyle: "italic" }}
                          >
                            (Required)
                          </span>
                        </span>
                      </Form.Label>
                      <div className="d-block w-100">
                        <Calendar
                          value={formData.childDob}
                          onChange={(e) =>
                            handleDateChange("childDob", e.value)
                          }
                          showIcon
                          dateFormat="mm-dd-yy"
                          placeholder="Date of Birth"
                          required
                          className="w-100"
                          inputClassName="form-control"
                        />
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold">
                        Party Date Request{" "}
                        <span
                          className="text-danger"
                          style={{ fontSize: "0.9rem", fontWeight: "normal" }}
                        >
                          <span
                            style={{ fontSize: "0.7rem", fontStyle: "italic" }}
                          >
                            (Required)
                          </span>
                        </span>
                      </Form.Label>
                      <div className="d-block w-100">
                        <Calendar
                          value={formData.partyDate}
                          onChange={(e) =>
                            handleDateChange("partyDate", e.value)
                          }
                          showIcon
                          dateFormat="mm-dd-yy"
                          placeholder="Party Date Request"
                          required
                          className="w-100"
                          inputClassName="form-control"
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold">
                        Preferred Start Time{" "}
                        <span
                          className="text-danger"
                          style={{ fontSize: "0.9rem", fontWeight: "normal" }}
                        >
                          <span
                            style={{ fontSize: "0.7rem", fontStyle: "italic" }}
                          >
                            (Required)
                          </span>
                        </span>
                      </Form.Label>
                      <div className="d-flex gap-2">
                        <Form.Select
                          value={formData.startTimeHH}
                          onChange={(e) =>
                            handleTimeChange("startTimeHH", e.target.value)
                          }
                        >
                          {[
                            "01",
                            "02",
                            "03",
                            "04",
                            "05",
                            "06",
                            "07",
                            "08",
                            "09",
                            "10",
                            "11",
                            "12",
                          ].map((h) => (
                            <option key={h} value={h}>
                              {h}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Select
                          value={formData.startTimeMM}
                          onChange={(e) =>
                            handleTimeChange("startTimeMM", e.target.value)
                          }
                        >
                          {["00", "15", "30", "45"].map((m) => (
                            <option key={m} value={m}>
                              {m}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Select
                          value={formData.startTimeAmpm}
                          onChange={(e) =>
                            handleTimeChange("startTimeAmpm", e.target.value)
                          }
                        >
                          <option value="AM">AM</option>
                          <option value="PM">PM</option>
                        </Form.Select>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <hr className="my-4" style={{ borderColor: "#e0e0e0" }} />

                {/* 2. Party Details & Pricing */}
                <h5
                  className="mb-4"
                  style={{ color: "#f7931a", fontWeight: "bold" }}
                >
                  Party Details & Pricing
                </h5>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold">
                        How many players will be at the event?{" "}
                        <span
                          className="text-danger"
                          style={{ fontSize: "0.9rem", fontWeight: "normal" }}
                        >
                          <span
                            style={{ fontSize: "0.7rem", fontStyle: "italic" }}
                          >
                            (Required)
                          </span>
                        </span>
                      </Form.Label>
                      <Form.Select
                        name="numberOfPlayers"
                        value={formData.numberOfPlayers}
                        onChange={handleInputChange}
                        required
                      >
                        {[20, 25, 30, 35, 40].map((val) => (
                          <option key={val} value={val}>
                            {val}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold">
                        3 Hours Of Gym Space @ $150{" "}
                        <span
                          className="text-danger"
                          style={{ fontSize: "0.9rem", fontWeight: "normal" }}
                        >
                          <span
                            style={{ fontSize: "0.7rem", fontStyle: "italic" }}
                          >
                            (Required)
                          </span>
                        </span>
                      </Form.Label>
                      <Form.Select
                        name="gymSpace"
                        value={formData.gymSpace}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="3 Hours - $450">3 Hours - $450</option>
                        <option value="4 Hours - $600">4 Hours - $600</option>
                        <option value="5 Hours - $750">5 Hours - $750</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold d-block">
                        Equipment Rental - $75{" "}
                        <span
                          className="text-danger"
                          style={{ fontSize: "0.9rem", fontWeight: "normal" }}
                        >
                          <span
                            style={{ fontSize: "0.7rem", fontStyle: "italic" }}
                          >
                            (Required)
                          </span>
                        </span>
                      </Form.Label>
                      {/* <div style={{height: "10px"}}> */}
                      {/* <div> */}
                      <Form.Check
                        inline
                        type="radio"
                        label="Yes"
                        name="equipmentRental"
                        value="Yes"
                        checked={formData.equipmentRental === "Yes"}
                        onChange={handleInputChange}
                        required
                      />
                      <Form.Check
                        inline
                        type="radio"
                        label="No"
                        name="equipmentRental"
                        value="No"
                        checked={formData.equipmentRental === "No"}
                        onChange={handleInputChange}
                        required
                      />
                      {/* </div> */}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold d-block">
                        Birthday Party Activity Specialists.{" "}
                        <span
                          className="text-danger"
                          style={{ fontSize: "0.9rem", fontWeight: "normal" }}
                        >
                          <span
                            style={{ fontSize: "0.7rem", fontStyle: "italic" }}
                          >
                            (Required)
                          </span>
                        </span>
                      </Form.Label>
                      {(() => {
                        const players = parseInt(formData.numberOfPlayers);
                        const { count, price } = getSpecialistPackage(players);
                        return (
                          <Form.Check
                            type="radio"
                            label={`${count} Specialists - $${price}`}
                            value="Yes"
                            checked={true}
                            readOnly
                          />
                        );
                      })()}
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold d-block">
                    2 Slices of Pizza & Soda/Water for each participant.{" "}
                    <span
                      className="text-danger"
                      style={{ fontSize: "0.9rem", fontWeight: "normal" }}
                    >
                      <span style={{ fontSize: "0.7rem", fontStyle: "italic" }}>
                        (Required)
                      </span>
                    </span>
                  </Form.Label>
                  <Form.Check
                    type="radio"
                    label="$7 Per Player"
                    name="pizzaOption"
                    value="Yes"
                    checked={true}
                    readOnly
                  />
                </Form.Group>

                <hr className="my-4" style={{ borderColor: "#e0e0e0" }} />

                {/* 3. Cake & Adult Food */}
                <h5
                  className="mb-4"
                  style={{ color: "#f7931a", fontWeight: "bold" }}
                >
                  Cake & Adult Food
                </h5>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold">
                        Would you like us to provide a custom Basketball
                        Birthday Cake?
                      </Form.Label>
                      <Form.Select
                        name="customCake"
                        value={formData.customCake}
                        onChange={handleInputChange}
                      >
                        <option value="No">No</option>
                        <option value="If yes, add $3 per player.">
                          If yes, add $3 per player.
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold">
                        Number of Adults Attending{" "}
                        <span
                          className="text-danger"
                          style={{ fontSize: "0.9rem", fontWeight: "normal" }}
                        >
                          <span
                            style={{ fontSize: "0.7rem", fontStyle: "italic" }}
                          >
                            (Required)
                          </span>
                        </span>
                      </Form.Label>
                      <Form.Select
                        name="numberOfAdults"
                        value={formData.numberOfAdults}
                        onChange={handleInputChange}
                        required
                      >
                        {[20, 25, 30, 35, 40].map((val) => (
                          <option key={val} value={val}>
                            {val}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold">
                        Would you like to purchase food for adults?{" "}
                        <span
                          className="text-danger"
                          style={{ fontSize: "0.9rem", fontWeight: "normal" }}
                        >
                          <span
                            style={{ fontSize: "0.7rem", fontStyle: "italic" }}
                          >
                            (Required)
                          </span>
                        </span>
                      </Form.Label>
                      <Form.Select
                        name="adultFoodOption"
                        value={formData.adultFoodOption}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="No">No</option>
                        <option value="Yes, I would like to utilize the options available from Shootin’ School. (add $18 per number of Adults selected)">
                          Yes, I would like to utilize the options available
                          from Shootin’ School. (add $18 per number of Adults
                          selected)
                        </option>
                        <option value="Yes, however, we will bring our own food (add $150 outside food vendor))">
                          Yes, however, we will bring our own food (add $150
                          outside food vendor)
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    {formData.customCake === "If yes, add $3 per player." && (
                      <Form.Group>
                        <Form.Label className="fw-bold">
                          Select an Option of Cake{" "}
                          <span
                            className="text-danger"
                            style={{ fontSize: "0.9rem", fontWeight: "normal" }}
                          >
                            <span
                              style={{
                                fontSize: "0.7rem",
                                fontStyle: "italic",
                              }}
                            >
                              (Required)
                            </span>
                          </span>
                        </Form.Label>
                        <Form.Select
                          name="cakeOption"
                          value={formData.cakeOption}
                          onChange={handleInputChange}
                        >
                          <option value="">Select Cake Type</option>
                          <option value="Vanilla">Vanilla</option>
                          <option value="Chocolate">Chocolate</option>
                          <option value="Red Velvet">Red Velvet</option>
                        </Form.Select>
                      </Form.Group>
                    )}
                  </Col>
                </Row>

                {/* Outside Vendor Fee Display */}
                {formData.adultFoodOption ===
                  "Yes, however, we will bring our own food (add $150 outside food vendor))" && (
                  <div className="alert alert-warning">
                    <strong>Note:</strong> An outside vendor fee of $150 will be
                    added to your total.
                  </div>
                )}

                {/* Adult Food Menus */}
                {formData.adultFoodOption ===
                  "Yes, I would like to utilize the options available from Shootin’ School. (add $18 per number of Adults selected)" && (
                  <div
                    className="p-3 mb-3"
                    style={{ backgroundColor: "#fff", borderRadius: "8px" }}
                  >
                    <Form.Group className="mb-1">
                      <Form.Label className="fw-bold mb-2">
                        List 1{" "}
                        <span
                          className="text-danger"
                          style={{ fontSize: "0.9rem", fontWeight: "normal" }}
                        >
                          <span
                            style={{ fontSize: "0.7rem", fontStyle: "italic" }}
                          >
                            (Required)
                          </span>
                        </span>
                      </Form.Label>
                      <div className="d-flex flex-column gap-2">
                        {[
                          "Chicken Parmesa",
                          "Chicken Marsala",
                          "Chicken Franchese",
                        ].map((item) => (
                          <Form.Check
                            key={item}
                            type="radio"
                            label={item}
                            name="adultFoodList1"
                            value={item}
                            checked={formData.adultFoodList1 === item}
                            onChange={handleInputChange}
                          />
                        ))}
                      </div>
                    </Form.Group>

                    <hr className="my-2" style={{ borderColor: "#e0e0e0" }} />

                    <Form.Group className="mb-1">
                      <Form.Label className="fw-bold mb-2">
                        List 2{" "}
                        <span
                          className="text-danger"
                          style={{ fontSize: "0.9rem", fontWeight: "normal" }}
                        >
                          <span
                            style={{ fontSize: "0.7rem", fontStyle: "italic" }}
                          >
                            (Required)
                          </span>
                        </span>
                      </Form.Label>
                      <div className="d-flex flex-column gap-2">
                        {[
                          "Pasta with Vodka Sauce",
                          "Tortellini Alfredo",
                          "Pasta with Brocoli Rabe and Sausage",
                          "Pasta with Vegetables",
                        ].map((item) => (
                          <Form.Check
                            key={item}
                            type="radio"
                            label={item}
                            name="adultFoodList2"
                            value={item}
                            checked={formData.adultFoodList2 === item}
                            onChange={handleInputChange}
                          />
                        ))}
                      </div>
                    </Form.Group>

                    <hr className="my-2" style={{ borderColor: "#e0e0e0" }} />

                    <Form.Group className="mb-1">
                      <Form.Label className="fw-bold mb-2">
                        List 3{" "}
                        <span
                          className="text-danger"
                          style={{ fontSize: "0.9rem", fontWeight: "normal" }}
                        >
                          <span
                            style={{ fontSize: "0.7rem", fontStyle: "italic" }}
                          >
                            (Required)
                          </span>
                        </span>
                      </Form.Label>
                      <div className="d-flex flex-column gap-2">
                        {[
                          "Sausage and Peppers",
                          "Eggplant Rollatini",
                          "Eggplant Parmesan",
                        ].map((item) => (
                          <Form.Check
                            key={item}
                            type="radio"
                            label={item}
                            name="adultFoodList3"
                            value={item}
                            checked={formData.adultFoodList3 === item}
                            onChange={handleInputChange}
                          />
                        ))}
                      </div>
                    </Form.Group>
                  </div>
                )}

                <hr className="my-4" style={{ borderColor: "#e0e0e0" }} />

                {/* 4. Add-Ons */}
                <h5
                  className="mb-4"
                  style={{ color: "#f7931a", fontWeight: "bold" }}
                >
                  Add-Ons
                </h5>

                <Form.Group className="mb-4">
                  <Form.Label className="fw-bold d-block">
                    Party Favors (Select all that apply)
                  </Form.Label>
                  <div className="d-flex flex-column gap-2">
                    <Form.Check
                      type="checkbox"
                      label="Shootin’ School Goodie Bag Favor - Custom Shootin’ School Water bottle with assorted candies wrapped in cellophane packaging - $10 each"
                      name="goodieBags"
                      checked={formData.goodieBags}
                      onChange={handleInputChange}
                    />
                    <Form.Check
                      type="checkbox"
                      label="Shootin’ School T-Shirts ($12 each)"
                      name="tShirts"
                      checked={formData.tShirts}
                      onChange={handleInputChange}
                    />
                    <Form.Check
                      type="checkbox"
                      label="Official Shootin’ School Mesh Practice Jersey ($25 each)"
                      name="jerseys"
                      checked={formData.jerseys}
                      onChange={handleInputChange}
                    />
                    <Form.Check
                      type="checkbox"
                      label="Basketball Pinata ($100)"
                      name="pinata"
                      checked={formData.pinata}
                      onChange={handleInputChange}
                    />
                    <Form.Check
                      type="checkbox"
                      label="Shootin’ School Rubber Basketballs ($15 each)"
                      name="rubberBasketballs"
                      checked={formData.rubberBasketballs}
                      onChange={handleInputChange}
                    />
                  </div>
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label className="fw-bold">
                    Any special notes or requests?
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="notes"
                    value={formData.notes}
                    onChange={handleInputChange}
                    placeholder="Enter any additional information here..."
                  />
                </Form.Group>

                {/* Total Price Display */}
                <div
                  className="text-center my-4 p-3"
                  style={{ backgroundColor: "#fff3e0", borderRadius: "8px" }}
                >
                  <h3 className="fw-bold" style={{ color: "#f7931a" }}>
                    Estimated Total: ${totalPrice}
                  </h3>
                  <small className="text-muted">
                    *Final price may vary based on actual attendance and
                    options.
                  </small>
                </div>

                <div className="text-center">
                  <Button
                    type="submit"
                    className="btn-lg px-5 py-3 fw-bold border-0"
                    style={{
                      backgroundColor: "#f7931a",
                      color: "white",
                      filter: "brightness(0.86)",
                    }}
                  >
                    SUBMIT REGISTRATION
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Container>
      </div>
    </div>
  );
};

export default BirthdayPartiesRegistration;
